import Cookies from 'js-cookie';
import {jwtDecode} from "jwt-decode";
import apiRequest, {errorMessage, isDialogVisible} from "./api_request";
import {API_BASE_URL} from "../config";

export const useAuth = () => {
    const user = Cookies.get('user');

    const login = async (email: string, password: string) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/signin`, {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "email": email,
                    "password": password,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                errorMessage.value = errorData.message || 'Login failed';
                console.log("failed login")
                console.log(errorMessage.value)
                isDialogVisible.value = true;
                throw new Error(errorMessage.value);
            }

            const data = await response.json();
            Cookies.set('userId', JSON.stringify(data.id)); // Store user data
            Cookies.set('accessToken', data.accessToken); // Store access token
            Cookies.set('refreshToken', data.refreshToken); // Store refresh token
            window.location.href = '/'; // Redirect to dashboard
        } catch (error: any) {
            errorMessage.value = error.message;
            isDialogVisible.value = true;
        }
    };

    const refreshToken = async () => {
        try {
            const refreshToken = Cookies.get('refreshToken');

            if (!refreshToken) {
                throw new Error('No refresh token available');
            }

            const response = await fetch(`${API_BASE_URL}/api/auth/refreshtoken`, {
                method: 'POST',
                credentials: 'include', // ← این گزینه مهمه
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "refreshToken": refreshToken,
                })
            });

            if (!response.ok) {
                throw new Error('Failed to refresh token');
            }

            const data = await response.json();
            Cookies.set('accessToken', data.accessToken); // Update access token
        } catch (error: any) {
            errorMessage.value = error.message;
            logout(); // Log out the user if refresh fails
        }
    };
    const register = async (firstName: string, lastName: string, email: string, password: string, companyName: string, mobile: string) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/signup`, {
                method: 'POST',
                credentials: 'include', // ← این گزینه مهمه
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({firstName, lastName, email, password, companyName, mobile}),
            });

            if (!response.ok) {
                throw new Error('Registration failed');
            }

            const data = await response.json();
            Cookies.set('userId', JSON.stringify(data.user.id)); // Store user data
            Cookies.set('accessToken', data.accessToken); // Store access token
            Cookies.set('refreshToken', data.refreshToken); // Store refresh token
            window.location.href = '/'; // Redirect to dashboard
        } catch (error: any) {
            errorMessage.value = error.message;
            isDialogVisible.value = true;
        }
    };

    const getUsers = async () => {
        try {
            const url = `${API_BASE_URL}/api/auth/users`;
            const options = {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                },
            };
            return await apiRequest(url, options);
        } catch (error) {
            console.error('Error users:', error);
            throw error;
        }
    };

    const updateUser = async (user) => {
        console.log(user)
        try {
            const url = `${API_BASE_URL}/api/auth/users/`+user.id;
            const options = {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(user),
            };
            return await apiRequest(url, options);
        } catch (error) {
            console.error('Error users:', error);
            throw error;
        }
    };

    interface JwtPayload {
        exp: number; // Expiration time in seconds since the Unix epoch
        id: number;
        canUpload: boolean;
    }

    const isManager = (): boolean => {
        try {
            const token = Cookies.get('accessToken');
            const {id} = jwtDecode<JwtPayload>(token);
            return id == 1;
        } catch (error) {
            return false
        }

    }
    const canUpload = (): boolean => {
        try {
            const token = Cookies.get('accessToken');
            const {id,canUpload} = jwtDecode<JwtPayload>(token);
            return id == 1||canUpload;
        } catch (error) {
            return false
        }

    }
    const getToken = async (): Promise<string> => {
        try {
            const token = Cookies.get('accessToken');
            const {exp} = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
            if (exp < currentTime) {
                await refreshToken(); // Refresh token if expired
                return getToken();
            } else {
                return token;
            }
        } catch (error) {
            throw new Error('Auth failed\n please login again');
        }
    };

    const logout = () => {
        Cookies.remove('user'); // Clear user data
        Cookies.remove('accessToken'); // Clear access token
        Cookies.remove('refreshToken'); // Clear refresh token
        window.location.href = '/login'; // Redirect to login page
    };

    return {user, login, register, logout, getToken,isManager,getUsers,updateUser,canUpload};
};